import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { SelectedOption } from './useAllocationFilters';

/**
 * Opções do filtro da coluna Tags: as tags ativas, mais as já selecionadas
 * que saíram da lista (desativadas depois), para continuarem desmarcáveis.
 */
export function useTagFilterOptions(selected: SelectedOption[]): SelectedOption[] {
  const { data } = useQuery(allocationQueries.tagOptions());
  const active = (data ?? []).map((tag) => ({ id: tag.id, name: tag.name }));
  const missing = selected.filter((option) => !active.some((tag) => tag.id === option.id));
  return [...active, ...missing];
}
